import { TReportingPeriodTypeId } from './ReportingPeriodType';

export type TProgramId = number;

export interface Program {
  id: TProgramId;
  name: string;
  reporting_period_type_id: TReportingPeriodTypeId;
}
